<p>
  high-chart-sample works!
</p>
<div id="container" style="height: 400px; min-width: 310px"></div>